import CurrencyExchangeService from "./services/CurrencyExchangeService";

const createServicesContext = () => {
    const currencyExchangeService = new CurrencyExchangeService(
        process.env.REACT_APP_CURRENCY_EXCHANGE_API_URL,
    );

    return { currencyExchangeService };
};

export default createServicesContext();